export const PaymentMethodCodes = {
    ZELLE: 'TZELLE',
    MOBILE_PAYMENT: 'PMBVC',
    CC: 'TDCSTRIPE',
};
